import TypeRegroupement from '../../constants/feuilleSaisie/typeRegroupement';
import type TreeRow from '../../interfaces/feuilleSaisie/treeRow';
import type BaseFeuilleSaisie from '../feuilleSaisies/BaseFeuilleSaisie';
import BaseTypeRegroupement from './BaseTypeRegroupement';

class ChapitreTypeRegroupement extends BaseTypeRegroupement {
	constructor(chapitreArticleLie: boolean = false) {
		super();
		this.code = TypeRegroupement.CHAPITRE;
		this.codeColumnName = 'cha_code';
		this.libelleColumnName = 'cha_libelle';
		this.icon = {
			iconSet: 'Lucide',
			name: 'FolderClosed',
		};
		this.libelle = chapitreArticleLie ? 'Article' : 'Chapitre';
	}

	getLibelle(data: TreeRow, feuille: BaseFeuilleSaisie): string {
		if (feuille.chapitreArticleLie) {
			return null;
		}
		return super.getLibelle(data, feuille);
	}
}

export default ChapitreTypeRegroupement;
